import { render, staticRenderFns } from "./ship-prod.vue?vue&type=template&id=4d29d49f&scoped=true"
import script from "./ship-prod.vue?vue&type=script&lang=js"
export * from "./ship-prod.vue?vue&type=script&lang=js"
import style0 from "./ship-prod.vue?vue&type=style&index=0&id=4d29d49f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d29d49f",
  null
  
)

export default component.exports